export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail nebo uživatelské jméno',
      invalidEmailOrUsername: 'Nesprávný e-mail nebo uživatelské jméno',
      invalidCredentials: 'Neplatné přihlašovací údaje',
      invalidPassword: 'Nesprávné heslo',
      noInternetConnection: 'Bez připojení k internetu',
      pageNotFound_title: 'Stránka nenalezena',
      password: 'Heslo',
      projectManagement: 'Správa projektu',
      serverConnectionFailed: 'Připojení k serveru selhalo',
      unknownError: 'Neznámá chyba, zkuste to později',
      useSingleSignOn: 'Použít jednorázové přihlášení',
    },

    action: {
      logIn: 'Přihlásit se',
    },
  },
};
